import moment from "moment-timezone";
import styles from "./styles/ListItemGroup.module.scss";

export function ContentItemDate(props: { contentItem: ContentItem }) {
  const date = moment(props.contentItem.created_at).format("MMM D, YYYY");

  return (
    <span className={styles.date} suppressHydrationWarning>
      {date}
    </span>
  );
}
